import { millisecondsInDay } from 'date-fns/constants';

const SESSION_SHOWN_AT_KEY = 'wa_opt_in_session_shown_at';
const JOB_BOARD_SHOWN_KEY = 'wa_opt_in_job_board_shown';

const getItem = (key: string): string | null => {
  try {
    return globalThis.window === undefined ? null : localStorage.getItem(key);
  } catch {
    return null;
  }
};

const setItem = (key: string, value: string): void => {
  try {
    if (globalThis.window !== undefined) localStorage.setItem(key, value);
  } catch {
    // Safari private mode and similar throw on write - the throttle degrades to "always allow".
  }
};

export const isWithinWaOptInSession = (): boolean => {
  const sessionShownAt = Number(getItem(SESSION_SHOWN_AT_KEY));
  return Boolean(sessionShownAt) && Date.now() - sessionShownAt < millisecondsInDay;
};

export const markWaOptInShown = (): void => {
  setItem(SESSION_SHOWN_AT_KEY, String(Date.now()));
};

export const hasWaOptInEverShownOnJobBoard = (): boolean => getItem(JOB_BOARD_SHOWN_KEY) === '1';

export const markWaOptInJobBoardShown = (): void => {
  setItem(JOB_BOARD_SHOWN_KEY, '1');
};
